import { Trans, useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import i18n from "../../libs/i18";
export const AboutUs = () => {
  const { t } = useTranslation(["about_us"]);
  console.log(typeof t("corporate-capabilities-description"));
  return (
    <div className="container py-5 ws-pre-line d-flex flex-column ">
      <h1>{t("title")}</h1>
      <div>
        <h2>{t("history")}</h2>
        <p>{t("history-description")}</p>
      </div>

      <motion.div
        initial={{ y: 150, opacity: 0.5 }}
        whileInView={{ y: 0, opacity: 1 }}
        transition={{ type: "spring", bounce: 0.2, duration: 0.5 }}
        className="row gap-2 gap-md-0"
      >
        <div className="col-12 col-md-6 px-md-4 custom-box px-md-5">
          <h2 className="py-md-3 py-1">{t("urban-metro-system")}</h2>

          <p>
            <Trans
              i18nKey="about_us:urban-metro-system-description"
              components={{
                strong: <strong style={{ color: "black" }} />,
              }}
              values={{
                gates: 1700,
                smartBus: "SMART BUS",
              }}
            />
          </p>
        </div>
        <div className="col-12 col-md-6 px-md-4 p-0  ">
          <img
            className="rounded"
            src="/assets/smart-clock-arayeh.png"
            alt="smart-clock-arayeh"
            width={"100%"}
            height={"100%"}
            style={{ objectFit: "cover" }}
          />
        </div>
      </motion.div>

      <div className="custom-box my-4 p-md-4">
        <h2>{t("corporate-capabilities")}</h2>
        <p>
          {i18n.language === "en" ? (
            <ul>
              <li> {t("corporate-capabilities-description.0")}</li>
              <li> {t("corporate-capabilities-description.1")}</li>
              <li> {t("corporate-capabilities-description.2")}</li>
              <li> {t("corporate-capabilities-description.3")}</li>
              <li> {t("corporate-capabilities-description.4")}</li>
            </ul>
          ) : (
            t("corporate-capabilities-description")
          )}
        </p>

        <p>
          {i18n.language === "en" && (
            <>
              <h2>{t("major-achievements")}</h2>
              <ul>
                <li> {t("major-achievements-description.0")}</li>
                <li> {t("major-achievements-description.1")}</li>
                <li> {t("major-achievements-description.2")}</li>
                <li> {t("major-achievements-description.3")}</li>
                <li> {t("major-achievements-description.4")}</li>
                <li> {t("major-achievements-description.5")}</li>
                <li> {t("major-achievements-description.6")}</li>
                <li> {t("major-achievements-description.7")}</li>
              </ul>
            </>
          )}
        </p>
      </div>
    </div>
  );
};
